module.exports = __webpack_public_path__ + "img/compass.38fed3ee.svg";